<template>
  <div id="app" :class="{ 'dark-mode': darkMode }">
    <Nav />
    <router-view />

    <Footer />
    <ChatBot/>
    <CanvasAnimation />
  </div>
</template>

<script>
import Nav from "./components/nav.vue";
import Footer from "./components/Footer.vue";
import ChatBot from "./components/features/chatbot.vue";
import CanvasAnimation from "./components/features/canvas.vue";
import { onMounted } from "vue";
import AOS from "aos";

export default {
  components: {
    Nav,
    Footer,
    ChatBot,
    CanvasAnimation,
  },
  data() {
    return {
      isScrollDown: false,
      darkMode: sessionStorage.getItem('darkMode') !== 'false',
    };
  },
  mounted() {
    Zoomtastic.mount({
      size: '95%',
      easing: 'ease',
      duration: 300,
      background: 'rgba(0, 0, 0, 0.9)',
      filter: 'drop-shadow(0 2px 16px rgba(0, 0, 0, 0.3))',
      animation: 'slide'
    });

    Zoomtastic.listen('[zoomtastic]', 'src');

    AOS.init();
  },
};
</script>

<style lang="scss">
html, body {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

#app {
  overflow-x: hidden;
  width: 100%;
  max-width: 100vw;
}

* { 
  margin: 0;
  padding: 0;
  font-family: "Segoe UI", Tahoma;
  transition: width 1s ease, height 1s ease, background-color 1s ease;
  box-sizing: border-box;
}
::-webkit-scrollbar {
  width: 15px;
  background: transparent;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: #888; 
  border-radius: 10px;
}


.dark-mode {
  background: #1A1A1A;
  color:white;
  .vue-typer {
    .custom.char {
      color: white;
    }
  }
  .btn, .btn-color-2{
    color: white !important;
  }
}


</style>
